(async () => {
    const { Core } = await importModule('Core');

    const TIER = { 'in-stock': 0, 'preorder': 1, 'out-of-stock': 2 };

    function isExplicitSort(defaultSort) {
        const params = new URLSearchParams(window.location.search);
        const current = params.get('sort_by');
        return current !== null && current !== defaultSort;
    }

    function sortGrid(grid) {
        const cards = Array.from(grid.querySelectorAll('[data-stock-status]'));
        cards.forEach((card, i) => { card._origIdx = i; });
        cards.sort((a, b) => {
            const tierDiff = (TIER[a.dataset.stockStatus] ?? 3) - (TIER[b.dataset.stockStatus] ?? 3);
            return tierDiff !== 0 ? tierDiff : a._origIdx - b._origIdx;
        });
        cards.forEach(card => grid.appendChild(card));
    }

    customElements.define('collection-sort-hierarchy', class extends Core {

        subscriptions = {
            'collection:updated': '_onUpdate'
        }

        render() {
            this.subscribe('collection:updated', { global: true });
            this._sort();
        }

        _onUpdate() {
            this._sort();
        }

        _sort() {
            if (isExplicitSort(this.dataset.defaultSort)) return;
            const grid = this.querySelector('[data-product-grid]');
            if (grid) sortGrid(grid);
        }
    });
})();